<template src="./slimCdIntegration.template.html"></template>
<script>
  import moment from "moment-timezone";
  import * as axios from "axios";
  import VeeValidate from "vee-validate";
  import Vue from "vue";
  import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
  Vue.use(VeeValidate);
  export default {
    components: {
      foliomodal,
    },
    name: "slimCdIntegration",
    props: [
      "parentComponentName",
      "unitId",
      "propertyId",
      "getIntegrationList",
      "componentIntegrationId",
      "selectiveIntegrationIds",
      "showSlimCdAccountPanel",
      "showSlimCdAccountDetails",
      "mainIntegration",
      "isIntegratedStatus",
      "isClient",
      "IsActive"
    ],
    data() {
      return {
        paymentAccountList: [],
        statusList: [
          {
            statusName: "Active",
            statusId: 1
          },
          {
            statusName: "Inactive",
            statusId: 0
          },
          {
            statusName: "Obsolete",
            statusId: -1
          },
          {
            statusName: "Remove Integration",
            statusId: -2
          }
        ],
        IsLive: null,
        paymentAccountEdit: null,
        isModalVisible: false,
        selectedPaymentAccount: {},
        modalParams: {},
        clientDetails: {},
        ShowAllAccount: true,
        isDropdownOpen: false,
        showDropdown: null,
      };
    },

    methods: {

      makePaymentAccountDefault(paymentAccount, event) {
        let vm = this;
        event.stopPropagation();
        let classsName = "#" + this.paymentAccountEdit;
        $(classsName).removeClass("show");
        // paymentAccount.IsDefault = true;
        vm.selectedPaymentAccount = paymentAccount;
        console.log("paymentAccount-mk--", paymentAccount, vm.selectedPaymentAccount);
        vm.isModalVisible = true;
        vm.modalParams = {
          popupTitle: `${paymentAccount.GatewayId === 1 ? 'Stripe' : 'Clearview Payment'}`,
          popupMessage: `Do you want to make Clearview Payments your Default payment processor?`,
          isRUPopup: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.updateAccCommissionConfig,
          noButtonCallback: vm.closePopup
        }
        // vm.updateAccCommissionConfig(paymentAccount);
      },
      removePaymentAccount(paymentAccount, statusId) {
        let vm = this;
        let classsName = "#" + this.paymentAccountEdit;
        $(classsName).removeClass("show");
        paymentAccount.StatusId = statusId;
        vm.updateAccCommissionConfig(paymentAccount);
      },
      updateAccCommissionConfig(paymentAccount) {
        let vm = this;
        console.log("isClient----", vm.propertyId);
        if (vm.selectedPaymentAccount && vm.selectedPaymentAccount.GatewayId) {
          vm.selectedPaymentAccount.IsDefault = true
        }
        paymentAccount = paymentAccount.GatewayId ? paymentAccount : vm.selectedPaymentAccount;
        console.log("update---paymenttac----", paymentAccount, vm.selectedPaymentAccount, paymentAccount.IsDefault);
        vm.$store.dispatch("dataRequestHandler", {
          key: "Update_Acc_Commission_Config",
          params: {
            ModuleAction: "Update_Acc_Commission_Config",
            propertyId: vm.propertyId,
            unitId: vm.unitId,
            isClient: vm.isClient,
            paymentAccount: paymentAccount,
            CommissionPercent: 0,
            CommissionAmmount: null,
            UseDefault: 0,
            IsLive: vm.IsLive == true ? 1 : 0
          },
          callback: function (err, response) {
            if (err) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Error!",
                header: "unable to update"
              });
              return;
            }
            if (response) {
              console.log("response in Update_Acc_Commission_Config", response);
              if (
                response[0] &&
                response[0].length > 0 &&
                response[0][0].ErrorMessage
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error!",
                  header: "unable to update"
                });
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "success",
                  message: "Updated the account successfully",

                });
                vm.getPaymentAccountDetails();
                vm.getIntegrationList()
              }
            }
          }
        });
        vm.isModalVisible = false
      },
      getPaymentListData(paymentAccount) {
        let vm = this;
        if (paymentAccount.StatusId == 0 && vm.ShowAllAccount) {
          return false;
        } else if (
          (paymentAccount.StatusId == 1 && vm.ShowAllAccount) ||
          !vm.ShowAllAccount
        ) {
          return true;
        }
      },
      closePopup() {
        let vm = this;
        vm.isModalVisible = false;
        vm.isDropdownOpen = false;
      },
      GetClientDetailById() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetClientDetailById",
          params: {
            ModuleAction: "GetClientDetailById",
          },
          callback: function (err, response) {
            if (response.recordsets[5].length) {
              vm.clientDetails = response.recordsets[5][0];
              vm.clientDetails.Email = response.recordsets[6][0].Email;
              vm.clientDetails.PhoneNumber =
                response.recordsets[6][0].PhoneNumber;
            }
            // vm.GetWheelHouseUserList();
          },
        });
      },
      getPaymentAccountDetails() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_PaymentAccount_Details",
          params: {
            ModuleAction: "Get_PaymentAccount_Details",
            propertyId: vm.propertyId,
            unitId: vm.unitId,
            isClient: vm.isClient,
            IsActive: vm.IsActive,
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in Get_PaymentAccount_Details", response);
              vm.stripeAccount = response[1][0];
              vm.IsLive = response[3][0].IsLive;
              // vm.connectToStripe();
              vm.paymentAccountList.splice(
                0,
                vm.paymentAccountList.length,
                ...response[2]
              );

              vm.paymentAccountList = vm.paymentAccountList.filter(data => data.GatewayId === 2)
              vm.$store.commit('setPaymentAccountList', vm.paymentAccountList);
              console.log("vm.paymentAccountList----", vm.paymentAccountList);

            }
          },
        });
      },
      toggleDropdown(event, id) {
        if (this.showDropdown === id) {
          this.showDropdown = null;
        } else {
          this.showDropdown = id;
        }
        console.log("before--showDropdown==", this.showDropdown);
        event.stopPropagation();
      },
      connectExistingAccount(event) {
        let vm = this;
        vm.showSlimCdAccountPanel(event);
      },

      handleDropdownClick(event, isDefault) {
        if (!isDefault) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      redirectToSlimcdDetail(event, wheelHouseIntegratedUser) {
        let vm = this;
        if (this.isDropdownOpen) {
          event.preventDefault();
          event.stopPropagation();
          return
        }
        if (vm.parentComponentName == 'integration' && vm.componentIntegrationId === 7) {
          vm.$router.push({
            name: "SlimcdIntegrationDetail",
            params: wheelHouseIntegratedUser
          });
        }

      },
    },
    watch: {
      reactiveShowSlimCdAccountDetails: function () {
        console.log(
          "showSlimCdAccountDetails: ",
          this.showSlimCdAccountDetails
        );
      },
      immediate: true,
    },

    computed: {
      reactiveShowSlimCdAccountDetails() {

        if (!this.showSlimCdAccountDetails) {
          this.getPaymentAccountDetails();
          console.log(
            "comp-showSlimCdAccountDetails: ",
            this.showSlimCdAccountDetails
          );
        }
      },
    },

    mounted() {
      let vm = this;
      vm.GetClientDetailById();
      vm.getPaymentAccountDetails();
      $(document).click(function (e) {
        vm.isDropdownOpen = vm.isDropdownOpen ? false : vm.isDropdownOpen;
        vm.showDropdown = null;
      });
    },
  };
</script>